import { useQuery } from '@tanstack/react-query'
import { ApiError, gebruiktMockApi, http } from './api'
import { ME } from './__fixtures__/inzet-fixtures'
import { vertraag } from './__fixtures__/vertraag'
import type { Me, Product, Rol } from './me-types'

export interface MeApi {
  get(): Promise<Me | null>
}

class RealMeApi implements MeApi {
  async get(): Promise<Me | null> {
    try {
      return await http.get<Me>('/api/me')
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) return null
      throw error
    }
  }
}

class MockMeApi implements MeApi {
  get(): Promise<Me | null> {
    return vertraag(ME, 120)
  }
}

export const meApi: MeApi = gebruiktMockApi ? new MockMeApi() : new RealMeApi()

export const meKeys = {
  me: ['me'] as const,
}

export function fetchMe(): Promise<Me | null> {
  return meApi.get()
}

export function useMe() {
  return useQuery({ queryKey: meKeys.me, queryFn: fetchMe, retry: false, staleTime: 60_000 })
}

export function useRol(): Rol | undefined {
  return useMe().data?.user.rol
}

export function useIsBeheerder(): boolean {
  return useRol() === 'beheerder'
}

export function useProduct(): Product | undefined {
  return useMe().data?.product
}

export function useMagRoosterBeheren(): boolean {
  return useProduct() === 'beheer'
}
